import { FlexibleContentFragment } from '@/fragments/FlexibleContent'
import { GravityFormsFragment } from '@/fragments/GravityForms'
import { PostsFragment } from '@/fragments/Posts'
import { gql } from '@apollo/client'

export const query = gql`
  ${GravityFormsFragment}
  ${PostsFragment}
  ${FlexibleContentFragment}
  query GetPageData {
    posts(first: 12) {
      nodes {
        ...PostsFeedItemFragment
      }
    }
    pages(where: { id: 346 }) {
      nodes {
        ...FlexibleContentFragment
        seo {
          metaDesc
          title
        }
      }
    }
    contactForm: gfForm(id: 1, idType: DATABASE_ID) {
      ...GravityFormsFragment
    }
  }
`
